import * as React from "react";
import * as S from "@styled";
import { SortableHandle } from "react-sortable-hoc";
import styled from "styled-components";
import colors from "shared/styles/colors";
import theme from "styled-theming";
import { ThemeType } from "shared/styles/theme";

const dragHandleColor = theme("mode", {
    [ThemeType.light]: colors.purplePrimary,
    [ThemeType.dark]: colors.purpleTertiary
}) 

export const DragHandleContainer = styled(S.FlexContainer)`
    color: ${dragHandleColor};
    font-size: 0.938rem;
    margin-bottom: 15px;
`

export const DragHandle = SortableHandle(() => {
    return <span style={{ cursor: "row-resize" }}><i className="ci-hamburger" ></i> Change order</span>;
});

export const ArrayItem: React.FC<IArrayItemProps> = (props?: IArrayItemProps, context?: any) => {
    
    return (
        <DragHandleContainer justifySpaceBetween={true}>
            <DragHandle />
            <span className="pointer" key={props?.id} onClick={props?.onDeleteClick}> <i className="ci-trash_full" aria-hidden="true" title={FRENDS.Localizations.Remove}></i></span>
        </DragHandleContainer>
    );
};

export interface IArrayItemProps {
    id: string;
    onDeleteClick: React.EventHandler<React.MouseEvent<HTMLElement>>;
}
